import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConsultationData } from 'src/app/models/consultdoctors';
import { PatientMedicalHistoryEdit } from 'src/app/models/history';
import { PromiseResult } from 'src/app/models/PromiseResult';
import { RestApi } from 'src/app/shared/apiUrls';

@Injectable({
    providedIn: 'root'
})
export class PatientviewService {
    constructor(private readonly http: HttpClient) { }
    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    fetchPersonalInfo(patient_guid: string, consultation_id: number): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(
                RestApi.Urls.PatientAccountApi + 'fetch/profile/' + patient_guid + '/' + consultation_id
            )
            .pipe(catchError(this.handleError));
    }

    fetchHistory(patient_guid: string): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(
                RestApi.Urls.PatientAccountApi + 'fetch/history/' + patient_guid
            )
            .pipe(catchError(this.handleError));
    }
    fetchPastConsultations(patient_guid: string): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(
                RestApi.Urls.PatientAccountApi + 'fetch/consultations/' + patient_guid
            )
            .pipe(catchError(this.handleError));
    }

    getPatientViewDocuments(patient_guid: string): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.PatientAccountApi + 'fetch/documents/' + patient_guid)
            .pipe(catchError(this.handleError));
    }

    fetchMedications(patient_guid: string): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(RestApi.Urls.PatientAccountApi + 'fetch/medications/' + patient_guid)
            .pipe(catchError(this.handleError));
    }

    savePatientMedicalHistory(data: PatientMedicalHistoryEdit): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(RestApi.Urls.PatientAccountApi + 'update/history', data)
            .pipe(catchError(this.handleError));
    }

    getDietData(data: ConsultationData) {
        return this.http
            .get<PromiseResult>(RestApi.Urls.PatientAccountApi + 'fetch/diet/' + data.patient_guid + '/' + data.consultation_id)
            .pipe(catchError(this.handleError));
    }


}
